import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const LegalPage = ({ type }) => {
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);

  const titles = {
    impressum: 'Imprint',
    datenschutz: 'Privacy Policy',
    agb: 'Terms & Conditions'
  };

  const contentKeys = {
    impressum: 'impressum_content',
    datenschutz: 'datenschutz_content',
    agb: 'agb_content'
  };

  useEffect(() => {
    const fetchContent = async () => {
      try {
        const res = await axios.get(`${API}/content`);
        setContent(res.data);
      } catch (err) {
        console.error('Failed to load content:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchContent();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen bg-white flex items-center justify-center">
        <div className="text-center">
          <div className="w-12 h-12 border-4 border-purple-200 border-t-purple-600 rounded-full animate-spin mx-auto mb-4"></div>
          <div className="text-gray-600">Lädt...</div>
        </div>
      </div>
    );
  }

  const pageContent = content?.[contentKeys[type]] || '';

  return (
    <div className="min-h-screen bg-white relative">
      {/* Background Blur Effects */}
      <div className="blur-circle-purple absolute -top-40 -right-40 w-[500px] h-[500px] opacity-20" />
      <div className="blur-circle-pink absolute bottom-0 -left-40 w-[400px] h-[400px] opacity-15" />

      <div className="max-w-3xl mx-auto px-4 py-12 relative z-10">
        <Link to="/" className="inline-flex items-center gap-2 text-purple-600 hover:text-purple-700 transition-colors mb-8 font-medium">
          <ArrowLeft className="w-4 h-4" />
          Back to Home
        </Link>
        
        <h1 className="text-4xl font-bold mb-8 text-gray-900 uppercase">
          {titles[type]}
        </h1>
        
        <div 
          className="prose prose-lg max-w-none text-gray-600 
            [&_h2]:text-2xl [&_h2]:font-bold [&_h2]:text-gray-900 [&_h2]:mt-8 [&_h2]:mb-4 [&_h2]:uppercase
            [&_h3]:text-xl [&_h3]:font-bold [&_h3]:text-gray-900 [&_h3]:mt-6 [&_h3]:mb-2
            [&_p]:mb-4 [&_p]:leading-relaxed
            [&_a]:text-purple-600 [&_a]:hover:text-purple-700
            [&_ul]:list-disc [&_ul]:pl-6 [&_ul]:mb-4
            [&_li]:mb-2"
          dangerouslySetInnerHTML={{ __html: pageContent }}
        />
        
        <div className="mt-12 pt-8 border-t border-gray-200 text-center text-sm text-gray-500">
          <p>© {new Date().getFullYear()} {content?.brand_name || 'nyza-studio'}</p>
        </div>
      </div>
    </div>
  );
};

export const ImpressumPage = () => <LegalPage type="impressum" />;
export const DatenschutzPage = () => <LegalPage type="datenschutz" />;
export const AGBPage = () => <LegalPage type="agb" />;

export default LegalPage;
